const OPENCLASSROOMS_NAME = 'openclassrooms';

export function filterPartners(partners) {
  return partners
    .map((partner) => partner.trim())
    .filter((partner) => {
      const isEmpty = !partner;
      const isOC = !isEmpty && partner.toLowerCase() === OPENCLASSROOMS_NAME;

      return !isEmpty && !isOC;
    });
}

export function getPartnersString(partners) {
  return filterPartners(partners).join(', ');
}
